module.exports = __webpack_public_path__ + "img/bd-hammerdin.edc3a132.png";